import copy from 'copy-to-clipboard';
import React from 'react';
import { useToasts } from 'react-toast-notifications';
import IconCopy from './icons/IconCopy';

interface Props {
    name: string;
    value: string;
    onCopyToClipboard?: () => void;
}

export default function CopyToClipboardLink({ name, value, onCopyToClipboard }: Props) {
    const { addToast } = useToasts();
    const handleCopyIdToClipboard = () => {
        copy(value);
        addToast('Copied to clipboard', { appearance: 'success' });
        onCopyToClipboard?.();
    };

    return (
        <button onClick={handleCopyIdToClipboard} className="link ml-auto text-sm">
            Copy {name} <IconCopy className="inline w-4 h-4" />
        </button>
    );
}
